import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getQuotaRequest = {};
var _getQuotaResponse = { quota: '_quota' };
var _quota = { currentCycleEndDate: 'google.protobuf.Timestamp' };
function resolveWixInnovationAssistantQuotaV2WixAssistantQuotaUrl(opts) {
    var domainToMappings = {
        _api_base_domain_: [
            {
                srcPath: '/wix-assistant-quota',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/wix-assistant-quota',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-assistant-quota',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/wix-assistant-quota',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/wix-assistant-quota',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/wix-assistant-quota',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/wix-assistant-quota',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/wix-assistant-quota',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Get the quota for the site. */
export function getQuota(payload) {
    var _a = serializer(_getQuotaRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getQuotaResponse, { _quota: _quota }).fromJSON;
    function __getQuota(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.innovation.assistant.v2.quota',
            method: 'GET',
            methodFqn: 'wix.innovation.assistant.quota.v2.WixAssistantQuota.GetQuota',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixInnovationAssistantQuotaV2WixAssistantQuotaUrl({
                protoPath: '/v2/quota',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getQuota.fromReq = fromReq;
    __getQuota.__isAmbassador = true;
    return __getQuota;
}
//# sourceMappingURL=http.impl.js.map